module.exports = __webpack_public_path__ + "img/reportedcoupons.28d10b94.svg";